import { ColumnConfig, SendInvoicedProductsColumnKey } from '../model';

export const sendInvoicedProductsConfig: Record<
  SendInvoicedProductsColumnKey,
  ColumnConfig
> = {
  sNo: {
    name: 'S. No',
  },
  skuCode: {
    name: 'SKU Code',
  },
  productTitle: {
    name: 'Product Title',
  },
  orderedQty: {
    name: 'Ordered QTY',
  },
  invoiceAmount: {
    name: 'Invoice Amount',
  },
};
